// As letras do avatar do topo da tela Inicio (spec 2026-09-29, item 1).
export function iniciaisDoNome(nome: string): string {
  const partes = nome.trim().split(/\s+/).filter(Boolean)
  if (partes.length === 0) return '?'
  const letras = partes.length === 1 ? partes[0][0] : partes[0][0] + partes[partes.length - 1][0]
  return letras.toUpperCase()
}
